import { InsightsTimeframes } from '@griply/types';
import { createContext } from 'react';
import { Timestamp } from 'shared/types/timestamp';

export type InsightsTimeframeContextValue = {
  timeframe: InsightsTimeframes;
  setTimeframe: (timeframe: InsightsTimeframes) => void;
  referenceDate: Timestamp;
  startDate: Timestamp;
  endDate: Timestamp;
  onPrev: () => void;
  onToday: () => void;
  onNext: () => void;
  isNextDisabled: boolean;
};

export const InsightsTimeframeContext = createContext<
  InsightsTimeframeContextValue | undefined
>(undefined);
